import { Tkv2OrderAttachment, schAloftArea } from '@aloft/toolkit-shared';
import { UseQueryResult } from '@tanstack/react-query';

import { useParams } from 'react-router';

import { constellation1ListingsToVacantLandSalesProps } from '../components/VacantLandSales/constellation1ListingsToVacantLandSalesProps.ts';
import { VacantLandSalesProperty } from '../components/VacantLandSales/types.ts';
import { selectEditablePropertyDataById } from '../redux/features/selectors/propertyDataSelectors/editablePropertyDataSelectors.ts';
import { selectSiteCostPerSf } from '../redux/features/selectors/selectSiteCostPerSf.ts';
import { useAppSelector } from '../redux/hooks.ts';
import { useGetVacantLandSales } from './api/toolkitComponents.ts';

export const useVacantLandSales = (): VacantLandSalesProperty[] | undefined => {
  const orderID = useParams().orderId!;

  const subjectEditableData = useAppSelector((state) =>
    selectEditablePropertyDataById(state, 'subject'),
  );
  const subjectSiteSize = subjectEditableData?.site?.area;
  const subjectCoordinates = subjectEditableData?.propertyIdentification?.coordinates;
  const subjectCostPerSF = useAppSelector((state) => selectSiteCostPerSf(state, 'subject'));

  const { data, error, isLoading }: UseQueryResult<Tkv2OrderAttachment<'vacantLandSales'>> =
    useGetVacantLandSales({ pathParams: { orderID } });

  if (isLoading || error || !data || data.body.body.status !== 'found') return undefined;

  const { results } = data.body.body.output;
  let vacantLandSales = constellation1ListingsToVacantLandSalesProps(results, subjectCoordinates);

  if (subjectCostPerSF) {
    vacantLandSales = vacantLandSales.filter(({ lotSize, salePrice }) => {
      const siteSize = lotSize?.getUnitAmount('sqft');

      if (!siteSize || !salePrice) return false;
      const costPerSF = salePrice.div(siteSize).toDollarLike();

      return (
        costPerSF <= subjectCostPerSF.toDollarLike() * 2 &&
        siteSize <= schAloftArea.parse(subjectSiteSize).getUnitAmount('sqft') * 2
      );
    });
  }

  return vacantLandSales;
};
